import React from "react";

const AboutDetail = () => {
  return (
    <>
      <section className="about_us mt_100 xs_mt_70">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-xl-6 col-lg-6 wow fadeInLeft"
              data-wow-duration="1s"
            >
              <div className="about_us_img">
                <div className="img">
                  <img
                    src="images/contact_banner.jpg"
                    alt="about us"
                    className="img-fluid w-100"
                  />
                </div>
                {/* <h3>
                  12+ <span>Years experience</span>
                </h3> */}
                {/* <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Cupiditate officiis architecto reiciendis.
                  <span>jhon deo</span>
                </p> */}
              </div>
            </div>

            <div
              className="col-xl-6 col-lg-6 wow fadeInRight"
              data-wow-duration="1s"
            >
              <div className="section_heading mb_25 ">
                <h4 className="fs-2">About Us</h4>
                {/* <h2>Helathy Foods Provider</h2> */}
              </div>
              {/* <div className="about_us_text">
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Cupiditate aspernatur molestiae minima pariatur consequatur
                  voluptate sapiente deleniti soluta,.
                </p>
                <ul>
                  {[1, 2, 3].map((e, i) => (
                    <li>
                      <h4>trusted partner</h4>
                      <p>
                        Lorem Ipsum Dolor Sit Amet Consectetur, Adipisicing
                        Elit. Minus, Officiis Placeat Iusto Quasi Adipisci
                        Impedit Delectus Beatae Ab Maxime.
                      </p>
                    </li>
                  ))}
                </ul>
              </div> */}
              <p className="font-20">
                Welcome to <strong>Afrikan BBQ</strong>, Spokane’s premier
                destination for authentic African-inspired barbecue. We take
                pride in blending the vibrant flavors of African cuisine with
                the artistry of barbecue to create a truly unique dining
                experience.
              </p>
              <p className="my-3 font-20">
                At Afrikan BBQ, we believe that food is more than just
                sustenance it’s a way to bring people together, celebrate
                culture, and create lasting memories. Our recipes are deeply
                rooted in African culinary traditions, combining{" "}
                <strong>bold spices</strong>, <strong>rich marinades</strong>,
                and <strong>time-honored grilling techniques</strong> to deliver
                flavors that are as dynamic as they are delicious.
              </p>
              <p className="font-20">
                Afrikan BBQ LLC was founded with a passion for sharing the{" "}
                <strong>diverse</strong> and{" "}
                <strong>flavorful cuisine of Africa</strong> with the Spokane
                community. Our team is dedicated to delivering{" "}
                <strong>exceptional food</strong> and warm hospitality. Whether
                you’re trying us for the first time or you’re a regular
                customer, we strive to make every bite{" "}
                <strong>unforgettable</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutDetail;
